/**
 * Which roleplay modes a program offers, as `{ guided, quick, video }` booleans.
 * The single home for the rules every roleplay entry point follows:
 *
 * - A mode is on unless the program explicitly stores `false`, so a program saved
 *   before `roleplayModes` existed (or missing a key) offers everything.
 * - Guided additionally needs at least one roleplay category; without one it would
 *   open an empty scenario grid.
 * - No program selected means no roleplay at all.
 */
export function availableRoleplayModes(program) {
  if (!program) {
    return { guided: false, quick: false, video: false };
  }

  const modes = program.roleplayModes || {};

  return {
    guided: modes.guided !== false && program.roleplayCategories?.length > 0,
    quick: modes.quick !== false,
    video: modes.video !== false,
  };
}

/** Whether the program offers any roleplay mode at all (drives the nav entry). */
export function hasAnyRoleplayMode(program) {
  const { guided, quick, video } = availableRoleplayModes(program);
  return guided || quick || video;
}
